
export default class InfoLentesBuilder {
  static build({
    descripcion, pvp, pvo, ojo, diametro, indice, material, foco, esRx, datosMontura, suplementos, estadistica, alturaFocal, info_trazadora,
  }) {
    const infoLente = {
      descripcion,
      pvp, // precio lente sin suplementos
      pvo, // costo lente
      ojo,
      diametro,
      indice,
      material,
      foco,
      esRx,
      datosMontura: {
        datosOma: datosMontura.datosOma,
        id: datosMontura.id,
        descripcion: datosMontura.descripcion,
        tieneFormaOma: datosMontura.tieneFormaOma,
        diametroMinimo: datosMontura.diametroMinimo,
      },
      suplementos,
    };
    if (estadistica && estadistica.catalogoDetalleId && estadistica.catalogoDetalleId !== '') {
      infoLente.estadistica = {
        ...estadistica,
        catalogoDetalleId: parseInt(estadistica.catalogoDetalleId, 10),
        miCatalogoId: parseInt(estadistica.miCatalogoId, 10),
        colorDetalleId: parseInt(estadistica.colorDetalleId, 10),
        tipoProgresivoId: parseInt(estadistica.tipoProgresivoId, 10),
      };
    }
    if (alturaFocal !== null) {
      infoLente.alturaFocal = alturaFocal;
    }
    if (info_trazadora !== null) {
      infoLente.info_trazadora = info_trazadora;
    }
    return infoLente;
  }
}
